module.exports = __webpack_public_path__ + "media/ascorbic-large.b438a6c6.mp4";